import Abstract from '../view/abstract.js';

export default class TripListUl extends Abstract {
  getTemplate() {
    return '<ul class="trip-events__list"></ul>';
  }
}
